export default {
    rs: {
        merchandiser: "Merchandiser",
        prijavaNaSistem: "Prijava na sistem",
        lozinka: "Lozinka",
        prijaviSe: "Prijavi se",
        zaboravljenaLozinka: "Zaboravljena lozinka",
        obnovaLozinke: "Obnova lozinke",
        nazad: "Nazad",
        posalji: "Pošalji!",
        unesiteVasEmail: "Unesite Vaš E-mail",
        dobrodosli: "Dobrodošli",
        odjava: "Odjava",
        dashboard: "Kokpit",
        sifarnici: "Šifarnici",
        novihPoruka: "Novih poruka",
        pogledajSvePoruke: "Pogledaj sve poruke",
        novePoruke: "Nove poruke",
        nemaNovihPoruka: "Nema novih poruka",
        korisnikaOnline: "korisnika online",
        meni: "Meni",
        artikli: "Artikli",
        email: "E-mail",
        zapamtiMe: "Zapamti me",
        neuspesnaPrijava: "Neuspešna prijava",
        poruke: "Poruke",
        onlineKorisnici: "Online korisnici",
        kod: "Kod",
        naziv: "Naziv",
        kratkiNaziv: "Kratki naziv",
        artikal: "Artikal",
        greska: "Greška",
        informacija: "Informacija",
        morateIzabratiSliku: "Morate izabrati sliku",
        grupa: "Grupa",
        greskaPrilikomUcitavanja: "Greška prilikom učitavanja",
        opis: "Opis",
        cena: "Cena",
        pdv: "PDV [%]",
        redosled: "Redosled",
        vidljiv: "Vidljiv",
        sacuvaj: "Sačuvaj",
        novi: "Novi",
        "nisu sva obavezna polja popunjena":
            "Nisu sva obavezna polja popunjena",
        podaciUspesnoSacuvani: "Podaci su uspešno sačuvani",
        greskaPrilikomUcitavanjaGrupa: "Greška prilikom učitavanja grupa",
        neuspesnoCuvanjePodataka:
            "Greška prilikom čuvanja podataka. Pokušajte ponovo",
        trgovinskiLanci: "Trgovinski lanci",
        stalci: "Stalci",
        oznaka: "Oznaka",
        objekti: "Objekti",
        pretraga: "Pretraga",
        rezultati: "Rezultati",
        rezultatiNaMapi: "Rezultati na mapi",
        pib: "PIB",
        adresa: "Adresa",
        mesto: "Mesto",
        kategorija: "Kategorija",
        snabdevac: "Snabdevač",
        poseta: "Poseta",
        odgovornaOsoba: "Odgovorna osoba",
        trgovinskiLanac: "Trgovinski lanac",
        tip: "Tip",
        ruta: "Ruta",
        nijeKategorizovan: "Nije kategorizovan",
        ocenaPozicije: "Ocena pozicije",
        ponisti: "Poništi",
        pretrazi: "Pretraži",
        DATE_FORMAT: "DD.MM.YYYY",
        DATE_TIME_FORMAT: "DD.MM.YYYY HH:mm",
        osnovno: "Osnovno",
        dodatno: "Dodatno",
        promet: "Promet",
        posete: "Posete",
        slike: "Slike",
        lokacija: "Lokacija",
        beleske: "Beleške",
        kategorizacija: "Kategorizacija",
        pozicije: "Pozicije",
        adresaIsporuke: "Adresa isporuke",
        postanskiBrojGradDrzava: "Mesto",
        posBr: "Poš. broj",
        napomena: "Napomena",
        obrisi: "Obriši",
        morateIzabratiObjekatPreBrisanja:
            "Morate izabrati objekat pre brisanja",
        objekatUspesnoObrisan: "Objekat uspešno obrisan",
        potvrda: "Potvrda",
        da: "Da",
        ne: "Ne",
        "da li ste sigurni da zelite da obrisete objekat?":
            "Da li ste sigurni da želite da obrišete objekat?",
        neuspesnoUcitavanjePodataka: "Neuspešno učitavanje podataka",
        neuspesnoBrisanjeObjekta: "Neuspešno brisanje objekta",
        prodaja: "Prodaja",
        distributer: "Distributer",
        prodavac: "Prodavac",
        brojKasa: "Broj kasa",
        "podaci nisu validni": "Podaci nisu validni",
        poslovodja: "Poslovodja",
        telefon: "Telefon",
        neuspesnoUcitavanjaPrometa: "Neuspešno učitavanja prometa",
        neuspesnoUcitavanjePoseta: "Neuspešno učitavanja poseta",
        godina: "Godina",
        mesec: "Mesec",
        vrednost: "Vrednost",
        kol: "Kol.",
        poslednjaPoseta: "Poslednja poseta",
        "brojPoseta(poslednjaGodina)": "Broj poseta (poslednja godina)",
        datum: "Datum",
        tipStalka: "Tip stalka",
        pozicijaStalka: "Pozicija stalka",
        dodatnaPozicija: "Dodatna pozicija",
        stalak: "Stalak",
        uMagacinu: "U magacinu",
        facings: "Facings",
        imaNalepnicu: "Ima nalepnicu",
        promene: "Promene",
        neuspesnoUcitavanjeSlika: "Neuspešno učitavanja slika",
        neuspesnoUcitavanjeStalaka: "Neuspešno učitavanja stalaka",
        neuspesnoUcitavanjeBeleski: "Neuspešno učitavanja beleški",
        trenutnoNemaUnetihSlika: "Trenutno nema unetih slika",
        nemaBeleski: "Nema beleški",
        mestoProdaje: "Mesto prodaje",
        velicina: "Veličina",
        brojStanovnika: "Broj stanovnika",
        naselje: "Naselje",
        mikroLokacija: "Mikro lokacija",
        glavnaISporednaUlica: "Glavna i sporedna ulica",
        nalaziSeUBlizini: "Nalazi se u blizini",
        autobuskaStanica: "Autobuska stanica",
        naseljeSa: "Naselje sa",
        cenaNekretnineUMestu: "Cena nekretnine u mestu",
        tipRadnje: "Tip radnje",
        excelIzvoz: "Excel izvoz",
        period: "Period",
        objekat: "Objekat",
        trajanjePosete: "Trajanje posete",
        ponovnePosete: "Ponovne posete",
        kreiran: "Kreiran",
        ponovnaPoseta: "Ponovna poseta",
        kasniDana: "Kasni dana",
        svrha: "Svrha",
        odgovoran: "Odgovoran",
        planiranePosete: "Planirane posete",
        kategorijaObjekta: "Kategorija objekta",
        intervalPosete: "Interval posete",
        datumPoslednjePosete: "Poslednja poseta",
        datumPlaniranePosete: "Planirana poseta",
        kasnjenje: "Kasnjenje",
        kat: "Kat",
        komentari: "Komentari",
        novaPoruka: "Nova poruka...",
        jeRekao: "je rekao",
        ocena: "Ocena",
        porukaNijePoslata: "Poruka nije poslata!",
        izvestaji: "Izveštaji",
        dnevniIzvestaji: "Dnevni izveštaji",
        dnevniIzvestaj: "Dnevni izveštaj",
        novihStalaka: "Novih stalaka",
        uvecanjeStalaka: "Uvećanje stalaka",
        umanjenjeStalaka: "Umanjenje stalaka",
        zamenaStalaka: "Zamena stalaka",
        promocija: "Promocija",
        isporuka: "Isporuka",
        ukupnoPoseta: "Ukupno poseta",
        predjenoKilometara: "Predjeno kilometara",
        gifts: "Gifts",
        nazivProdajnogMesta: "Naziv prodajnog mesta",
        lanac: "Lanac",
        aktivnost: "Aktivnost",
        zaliha: "Zaliha",
        prometPoDistributerima: "Promet po distributerima",
        januar: "Januar",
        februar: "Februar",
        mart: "Mart",
        april: "April",
        maj: "Maj",
        jun: "Jun",
        jul: "Jul",
        avgust: "Avgust",
        septembar: "Septembar",
        oktobar: "Oktobar",
        novembar: "Novembar",
        decembar: "Decembar",
        ucitaj: "Učitaj",
        ukupno: "Ukupno",
        kolicina: "Količina",
        prometIPoslednjaPoseta: "Promet i poslednja poseta",
        kupac: "Kupac",
        "posete(6meseci)": "Posete (6meseci)",
        preDana: "Pre dana",
        administracijaKorisnika: "Administracija korisnika",
        registrovaniKorisnici: "Registrovani korisnici",
        ime: "Ime",
        prezime: "Prezime",
        detaljiKorisnika: "Detalji korisnika",
        pristupniKod: "Pristupni kod",
        uloga: "Uloga",
        dnevnaAktivnostMerchandisera: "Dnevna aktivnost merchandisera",
        merchandisers: "Merchandisers",
        totalDana: "Total dana",
        prodatoArtikala: "Prodato artikala",
        isporuke: "Isporuke",
        vremeObrade: "Vreme obrade: ",
        slideShow: "Slide show",
        mesecniMerchandisingIzvestaj: "Mesečni merchandising izveštaj",
        noviStalak: "Novi stalak",
        uvecanje: "Uvecanje",
        umanjenje: "Umanjenje",
        zamena: "Zamena",
        ukupnoKM: "Ukupno km",
        aktivnihDana: "Aktivnih dana",
        prosecnaOcena: "Prosečna ocena",
        brojDana: "Broj dana",
        prosek: "Prosek",
        dnevno: "Dnevno",
        ukupnoIntervencijaSaStalcima: "Ukupno intervencija sa stalcima",
        intervencijaSaStalcimaPoMerchandiseru:
            "Intervencija sa stalcima po merch.",
        brojPosetaPoMerchandiseru: "Broj poseta po merch.",
        brojKilometaraPoMerchandiseru: "Broj kilometara po merch.",
        merchandisersSlikePoseta: "Slike poseta",
        abcAnalizaKupaca: "ABC analiza kupaca",
        poProdatojKoliciniArtikala: "Po prodatoj količini artikala",
        prodataKolicina: "Prodata količina",
        dodeljenaKategorija: "Dodeljena kategorija",
        realnaKategorija: "Realna kategorija",
        brojMeseci: "Broj meseci",
        zalihe: "Zalihe",
        kolicinaPoFacingu: "Količina/Facing <",
        ukupnaZalihaManjaOd: "Ukupna zaliha <",
        ukupnaZaliha: "Ukupna zaliha",
        posetuUradio: "Posetu uradio",
        korisnici: "Korisnici",
        sumarniIzvestaji: "Sumarni izveštaji",
        izvestajAktivnosti: "Izveštaj aktivnosti",
        dokumenta: "Dokumenta",
        narudzbenice: "Narudžbenice",
        total: "Ukupno",
        kreator: "Kreirao",
        role: "Uloga",
        "pregled dokumenta": "Pregled dokumenta",
        status: "Status",
        tipoviObjekata: "Tipovi objekata",
        kategorijeObjekata: "Kategorije objekata",
        distributeri: "Distributeri",
        aktivnosti: "Aktivnosti",
        ucesce: "Učešće",
        kumulativ: "Kumulativ",
        azurirajObjekte: "Ažuriraj objekte",
        minimalneZalihe: "Minimalne zalihe",
        "promeniLozinku": "Promeni lozinku",
        "rabat": "Rabat",
        "rokPlacanja": "Rok plaćanja",
        "uvecanje/umanjenje": "Uvećanje/umanjenje",
        "eanKod": "EAN",
        "uom": "Jedinica mere"
    },
};
